export interface AnalyticsConfiguration_XO {
  enabled?: boolean;
  token?: string;
}

export const AnalyticsConfiguration_XO_Graphql_Request_Fragment = `
  enabled
  token
`;
